import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField, formatDate } from "helpers/row-logic-helper";

import {
  shouldShowCashManagementReportingMisc,
  shouldShowWaiverStartDate,
  shouldShowWaiverEndDate
} from "./section-loan-cash-management-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  highPriority: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "High Priority",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultBooleanField(data, "covenants.highPriority"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingWaiver: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultBooleanField(data, "covenants.reportingWaiver", "Reporting has been waived", "Reporting has not been waived"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingWaiverStartDate: {
    isVisible: data => shouldShowWaiverStartDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: loan => formatDate(defaultField(loan, "covenants.reportingWaiverStartDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingWaiverEndDate: {
    isVisible: data => shouldShowWaiverEndDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver End Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: loan => formatDate(defaultField(loan, "covenants.reportingWaiverEndDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  cashManagementReportingMisc: {
    isVisible: data => shouldShowCashManagementReportingMisc(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Miscellaneous",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.cashManagementReportingMisc"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
